import EntryProjectData from "../../apps/entries/app/model/EntryProjectData";
import { BarrelUser } from "../api/model";

import { getDateDifference } from "./date";
import { exists } from "./object";

function getPopulatedOrganizationProjectsWithMembers<T extends EntryProjectData>(
    members: BarrelUser[],
    organizationProjects: T[]
): T[] {
    const membersObject = Object.fromEntries(members.map(member => [member.user._id, member]));

    return organizationProjects.map(project => ({
        ...project,
        users: project.users.map(projectUser => membersObject[projectUser.user._id])
            .filter(exists)
    }) as T);
}

function getRemainingFreeTrialDaysUntil(endDate: string): number {
    const HOURS_IN_DAYS = 24;
    const MIN_HOURS_FOR_ROUND_UP = 3;

    const differenceInHours = getDateDifference("h", new Date(), endDate);
    let dayCount = Math.floor(differenceInHours / HOURS_IN_DAYS);

    const remainderHours = differenceInHours % HOURS_IN_DAYS;
    if (dayCount > 0 && remainderHours >= MIN_HOURS_FOR_ROUND_UP) {
        dayCount++;
    }

    return dayCount;
}

export {
    getPopulatedOrganizationProjectsWithMembers,
    getRemainingFreeTrialDaysUntil
};
